/**
 * Fixed design canvas: 43" MWE panels mounted in PORTRAIT, so exactly
 * 1080x1920. Everything is authored in these coordinates and core/stage.ts
 * scales the whole stage to whatever viewport it lands in.
 */
export const STAGE_WIDTH = 1080
export const STAGE_HEIGHT = 1920

/**
 * Hub mode only (`?mode=hub`): return to the hub after this long without a touch.
 *
 * Keep this comfortably SHORTER than Fully's own "Screensaver Timer" if the
 * screensaver is ever used again, so the app resets to the hub before the
 * screensaver hides a stale detail page.
 */
export const IDLE_TIMEOUT_MS = 45_000

/** Keep in sync with --transition-screen in tokens.css. */
export const SCREEN_FADE_MS = 280

/** Taps in the top-left corner that open the diagnostics overlay. */
export const DIAG_TAP_COUNT = 5
export const DIAG_TAP_WINDOW_MS = 3_000

/* --------------------------------------------------------------- slideshow */

/**
 * The church website's list of live slides (jubilee-km-cloudflare,
 * GET /api/v1/kiosk/slides). Editors manage it in the website's admin.
 * `VITE_SLIDES_URL` points a local build at a local copy of the website.
 */
export const SLIDES_URL: string =
  import.meta.env.VITE_SLIDES_URL || 'https://jubilee-km.org/api/v1/kiosk/slides'

/** How long a slide stays up when the website does not say. */
export const SLIDE_INTERVAL_MS = 8_000
/** A per-slide duration from the website is clamped to this range. */
export const SLIDE_DURATION_MIN_MS = 3_000
export const SLIDE_DURATION_MAX_MS = 60_000
/** How often the panel asks the website for the list. */
export const SLIDE_REFRESH_MS = 5 * 60_000
/** Give up on a list request after this long and keep what is on screen. */
export const SLIDE_FETCH_TIMEOUT_MS = 15_000

/** Crossfade between slides when they change on their own. */
export const SLIDE_FADE_MS = 700
/** How long a released swipe takes to slide into place. */
export const SLIDE_SETTLE_MS = 260
/** A swipe longer than this share of the width turns the slide. */
export const SWIPE_THRESHOLD = 0.15
/** …and so does a short one faster than this (design px per ms). */
export const SWIPE_FLICK_VELOCITY = 0.6
/** A touch that moves less than this is a tap, which does nothing. */
export const TAP_SLOP_PX = 10

/**
 * Once a day, early in the morning, the panel reloads itself so it picks up a new
 * build even if Fully's nightly screen-off (and its reload on screen-on) does not
 * work on the board.
 */
export const SELF_RELOAD_AFTER_MS = 20 * 60 * 60_000
export const SELF_RELOAD_HOUR_NY = 4
export const SELF_RELOAD_CHECK_MS = 5 * 60_000

/** Set at build time (vite.config.ts) to the git commit it was built from. */
export const BUILD_ID: string = __BUILD_ID__
